export const LANGUAGE_PRIORITY = ["ru", "en", "ro"];

export function getTranslationLanguageCode(item: any): string {
  return (
    (item &&
      (item.LangCode ||
        item.langCode ||
        item.LanguageCode ||
        item.languageCode ||
        item.Code ||
        item.code)) ||
    ""
  )
    .toString()
    .trim()
    .toLowerCase();
}

export function sortByLanguagePriority<T>(items: T[]): T[] {
  return (items || [])
    .map((item, index) => ({ item, index }))
    .sort((left, right) => {
      const leftPriority = LANGUAGE_PRIORITY.indexOf(
        getTranslationLanguageCode(left.item)
      );
      const rightPriority = LANGUAGE_PRIORITY.indexOf(
        getTranslationLanguageCode(right.item)
      );
      const normalizedLeftPriority =
        leftPriority === -1 ? LANGUAGE_PRIORITY.length : leftPriority;
      const normalizedRightPriority =
        rightPriority === -1 ? LANGUAGE_PRIORITY.length : rightPriority;

      return (
        normalizedLeftPriority - normalizedRightPriority ||
        left.index - right.index
      );
    })
    .map(({ item }) => item);
}

export function findPreferredTranslation<T>(
  items: T[],
  hasContent: (item: T) => boolean = (item) => Boolean(item)
): T | undefined {
  return sortByLanguagePriority(items).find(hasContent);
}
